<script setup lang="ts">
// Le formulaire passe dans le slot par défaut (avec un `id`) ; les actions dans le slot
// `#actions` — le bouton submit s'y relie au formulaire via `form="<id>"` même s'il est hors de
// son arbre DOM. `headerClass` permet à l'hôte de surcharger l'en-tête (ex. marge supérieure
// mobile sans `mt-safe`).
withDefaults(defineProps<{ title: string; description?: string; headerClass?: string }>(), {
  headerClass: "mb-14 mt-safe text-center mx-auto max-w-3xl",
});
defineSlots<{ default(): unknown; actions(): unknown }>();
</script>

<template>
  <header :class="headerClass">
    <h1 class="text-5xl md:text-6xl font-semibold mb-2">{{ title }}</h1>
    <p v-if="description" class="text-xl md:text-2xl/snug">{{ description }}</p>
  </header>
  <div class="flex flex-col w-full max-w-114 mx-auto">
    <slot />
    <div v-if="$slots.actions" class="flex flex-col items-center grow-0 shrink-0 gap-y-5 pb-safe-or-6">
      <slot name="actions" />
    </div>
  </div>
</template>
